// third-party
import { createSlice } from '@reduxjs/toolkit';

// ── Initial state ─────────────────────────────────────────────────────────────
// No localStorage hydration — auth is determined server-side via httpOnly cookies.
// initializeAuth thunk calls GET /auth/profile to check if a valid session exists.
const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: true,  // true on boot until initializeAuth resolves
  error: null
};

// ==============================|| SLICE - AUTH ||============================== //

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.isLoading = true;
      state.error = null;
    },

    loginSuccess(state, action) {
      state.isLoading = false;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.error = null;
      // NO localStorage write — token lives in httpOnly cookie only
    },

    loginFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.user = null;
      // NO localStorage removal needed
    },

    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      state.isLoading = false;
      // Cookies are cleared by the server on POST /auth/logout
    },

    clearError(state) {
      state.error = null;
    },

    updateProfileSuccess(state, action) {
      state.user = {
        ...state.user,
        ...action.payload
      };
    },

    setLoading(state, action) {
      state.isLoading = action.payload;
    }
  }
});

export default auth.reducer;

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  clearError,
  updateProfileSuccess,
  setLoading
} = auth.actions;